import { typography } from "./typography"
import { color } from "./color"

export const theme = {
  color,
  typography,
}
